import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/credits")({
  component: () => <ComingSoonPage title="算力点数" />,
});
